import { SxProps } from '@mui/material';

export const headerSearchSuggestProductContainerSX = (isInDrawer: boolean): SxProps =>
	isInDrawer ? { px: '2.5px' } : { backgroundColor: 'transparent', maxWidth: '200px' };

export const headerSearchSuggestProductContentSX = (isInDrawer: boolean): SxProps =>
	isInDrawer ? { border: '1px solid #DADCE0' } : {};

export const headerSearchSuggestProductImgSX = (isInDrawer: boolean): SxProps =>
	isInDrawer
		? { width: '100%', objectFit: 'cover' }
		: { width: '200px', height: '200px !important' };

export const headerSearchSuggestProductInfoSX = (isInDrawer: boolean): SxProps =>
	isInDrawer
		? {
				height: '108px',
				p: '0px 9px 9px 9px',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-between',
				mt: '5px',
		  }
		: {};

export const headerSearchSuggestProductNameSX = (isInDrawer: boolean): SxProps =>
	isInDrawer
		? {
				fontSize: {
					xs: 'var(--font-size-small)',
					sm: 'var(--font-size-body)',
				},
				fontWeight: '600',
				color: '#2C2C2C',
				letterSpacing: '0px',
				display: '-webkit-box',
				WebkitLineClamp: 2,
				WebkitBoxOrient: 'vertical',
				textOverflow: 'ellipsis',
				overflow: 'hidden',
		  }
		: {
				color: '#2C2C2C',
				fontSize: { xs: 'var(--font-size-default)', sm: 'var(--font-size-body)' },
				fontWeight: '600',
				textDecoration: 'none',
				overflow: 'hidden',
				display: '-webkit-box',
				WebkitLineClamp: 2,
				WebkitBoxOrient: 'vertical',
				textOverflow: 'ellipsis',
				mb: '4px',
		  };

export const headerSearchSuggestProductBrandSX = (isInDrawer: boolean): SxProps =>
	isInDrawer
		? {
				color: '#505050',
				fontSize: {
					xs: 'var(--font-size-small)',
					sm: 'var(--font-size-body)',
				},
		  }
		: {
				color: '#2C2C2C',
				fontSize: 'var(--font-size-default)',
				textDecoration: 'none',
				fontWeight: '300',
		  };

export const headerSearchSuggestProductDiscountSX = (isInDrawer: boolean): SxProps =>
	isInDrawer
		? {
				color: '#AB2326',
				fontSize: { xs: 'var(--font-size-small)', sm: 'var(--font-size-body)' },
				fontWeight: '600',
				marginRight: '8px',
				textDecoration: 'none',
		  }
		: {
				color: '#AB2326',
				fontSize: 'var(--font-size-sm)',
				fontWeight: '600',
				marginRight: '8px',
				textDecoration: 'none',
		  };

export const headerSearchSuggestProductPriceSX = (
	isInDrawer: boolean,
	hasDiscount: boolean
): SxProps =>
	isInDrawer
		? {
				color: '#2C2C2C',
				fontSize: { xs: 'var(--font-size-small)', sm: 'var(--font-size-body)' },
				fontWeight: '600',
				textDecoration: hasDiscount ? 'line-through' : 'none',
		  }
		: {
				color: '#2C2C2C',
				fontSize: 'var(--font-size-sm)',
				fontWeight: '600',
				textDecoration: hasDiscount ? 'line-through' : 'none',
		  };
